import React, { Component } from 'react';
import Header from '../components/headers/logged_in.js';
import Footer from '../components/footer.js';

class LoggedInLayout extends Component {
  render() {
    return (
      <div>
        <Header />
        <main role="main" className="container">
          {this.props.children}
        </main>
        <Footer />
      </div>
    );
  }
}

export default LoggedInLayout;



// WEBPACK FOOTER //
// ./src/layouts/logged_in_layout.js